import script from "./SchemaSnapshot.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaSnapshot.vue?vue&type=script&setup=true&lang=js"

import "./SchemaSnapshot.vue?vue&type=style&index=0&id=a5ba881e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5ba881e"]])

export default __exports__